import { render } from "./USLightVehicle.vue?vue&type=template&id=e7fa7506&ts=true"
import script from "./USLightVehicle.vue?vue&type=script&lang=ts"
export * from "./USLightVehicle.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__